import { useTranslation } from 'react-i18next'

import { useErrorBoundary } from 'react-error-boundary'

import { AlertCircle } from 'lucide-react'

import { normalizedEnv } from '@/config/env'

import { SmartButton } from '@/components/ui-custom/SmartButton'

export const MainErrorFallback = () => {
  const { t } = useTranslation(['common'])
  const { resetBoundary } = useErrorBoundary()
  const subject = t('common:errors.reportSubject', 'Error Report')
  const body = t('common:errors.reportBody', "I encountered an error while using the app. Here's what happened:")

  return (
    <div role='alert' className='flex min-h-screen w-full items-center justify-center bg-gray-50 p-4'>
      <div className='bg-card text-card-foreground w-full max-w-md space-y-4 rounded-lg border p-6 shadow-sm'>
        <div className='flex flex-col items-center gap-4 text-center'>
          <div className='bg-destructive/15 rounded-full p-3'>
            <AlertCircle className='text-destructive h-8 w-8' />
          </div>

          <div className='space-y-2'>
            <h2 className='text-xl font-semibold tracking-tight text-red-600'>
              {t('common:errors.unexpectedError', 'Unexpected Error Occurred')}
            </h2>
            <p className='text-muted-foreground text-sm'>
              {t(
                'common:errors.errorDescription',
                "We couldn't complete your request. Please try refreshing the page or contact support."
              )}
            </p>
          </div>

          <SmartButton onClick={resetBoundary} className='mt-4 w-full max-w-xs' variant='outline'>
            {t('common:actions.refreshPage', 'Refresh Page')}
          </SmartButton>

          <a
            href={`mailto:${normalizedEnv.supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`}
            className='hover:text-primary inline-flex items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-medium text-gray-400 transition-colors'
          >
            {t('common:actions.contactSupport', 'Contact Support')}
          </a>
        </div>
      </div>
    </div>
  )
}
